<template>
  <div class="job-item-long" tag="article">
    <shimmer
      v-if="imageHead"
      :height="imageHeadHeight"
      :width="imageHeadWidth"
      class="job-item-long__img"
    ></shimmer>
    <div class="job-item-long__content">
      <paragraph-shimmer :withTitle="withTitle" :justified="justified" />
    </div>
  </div>
</template>
<script>
import shimmer from '@/components/shimmers/shimmer'
import paragraphShimmer from '@/components/shimmers/paragraph'

export default {
  components: {
    shimmer,
    paragraphShimmer
  },
  props: {
    withTitle: {
      default: true,
      type: Boolean
    },
    justified: {
      default: false,
      type: Boolean
    },
    imageHead: {
      default: true,
      type: Boolean
    },
    imageHeadHeight: {
      default: '125px',
      type: String
    },
    imageHeadWidth: {
      default: '150px',
      type: String
    }
  }
}
</script>
